'use client';

import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger } from 'src/shadcn/components/ui/tabs';
import { PricingTierSection } from './PricingTierSection';
import { PricingTierHeader } from './PricingTierHeader';
import { PricingTierDescription } from './PricingTierDescription';
import { PricingTierPrice } from './PricingTierPrice';
import { PricingTierFeature } from './PricingTierFeature';
import { PricingTierFeaturesList } from './PricingTierFeaturesList';
import { Button } from 'src/shadcn/components/ui/button';
import { yaserCalendlyLink } from '../HomePage/NewLandingContants';
import Link from 'next/link';

export const PricingTiers: React.FC = () => {
  const [selectedTier, setSelectedTier] = useState<'monthly' | 'annually'>(
    'monthly'
  );
  return (
    <div className=''>
      <div className='flex w-full items-center justify-center'>
        <Tabs
          className=''
          value={selectedTier}
          onValueChange={newValue => {
            switch (newValue) {
              case 'monthly':
              case 'annually':
                setSelectedTier(newValue);
            }
          }}
        >
          <TabsList className='m-auto'>
            <TabsTrigger value='monthly'>Monthly</TabsTrigger>

            <TabsTrigger value='annually'>Annually</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      <div className='m-auto my-10 grid max-w-5xl grid-cols-1 gap-10 md:grid-cols-2'>
        <PricingTierSection>
          <PricingTierHeader>Growth</PricingTierHeader>
          <PricingTierDescription>
            Everything you need for a small shop
          </PricingTierDescription>
          <PricingTierPrice
            monthly={12900}
            annually={119900}
            currentSelection={selectedTier}
          />

          <Link
            href={yaserCalendlyLink}
            className='flex w-full py-5'
            target='_blank'
          >
            <Button className='w-full' variant={'default'}>
              Buy now
            </Button>
          </Link>
          <PricingTierFeaturesList>
            <PricingTierFeature>14 day free trial</PricingTierFeature>
            <PricingTierFeature>Unlimited SMS</PricingTierFeature>
            <PricingTierFeature>Unlimited invoices</PricingTierFeature>
            <PricingTierFeature>Unlimited estimates</PricingTierFeature>
            <PricingTierFeature>Unlimited appointments</PricingTierFeature>
            <PricingTierFeature>
              Credit card processing fees recoup
            </PricingTierFeature>
            <PricingTierFeature>4 payment types</PricingTierFeature>
            <PricingTierFeature>Custom shop branding</PricingTierFeature>
            <PricingTierFeature>1 employee account</PricingTierFeature>
            <PricingTierFeature>1 location</PricingTierFeature>
            <PricingTierFeature>
              Customer reviews on work orders
            </PricingTierFeature>
          </PricingTierFeaturesList>
        </PricingTierSection>
        <PricingTierSection>
          <PricingTierHeader>Enterprise</PricingTierHeader>
          <PricingTierDescription>
            Everything you need for a small shop
          </PricingTierDescription>
          <PricingTierPrice
            monthly={0}
            annually={0}
            currentSelection={selectedTier}
            isCustom={true}
          />
          <Link
            href={yaserCalendlyLink}
            className='flex w-full py-5'
            target='_blank'
          >
            <Button className='w-full' variant={'outline'}>
              Contact us
            </Button>
          </Link>
          <PricingTierFeaturesList>
            <PricingTierFeature>14 day free trial</PricingTierFeature>
            <PricingTierFeature>Unlimited locations</PricingTierFeature>
            <PricingTierFeature>Unlimited employee accounts</PricingTierFeature>
            <PricingTierFeature>Expense management</PricingTierFeature>
            <PricingTierFeature>Priority support</PricingTierFeature>
          </PricingTierFeaturesList>
        </PricingTierSection>
      </div>
    </div>
  );
};
